import { createFileRoute } from '@tanstack/react-router';
import { defaultOrganizationId } from '@nest/ids';
import { z } from 'zod';
import { requirePermission } from '@/features/auth/access';
import { OpportunitiesPage } from '@/features/opportunity/list-page';
import { PlatformWorkspace } from '@/features/tenant/platform-workspace';

const opportunitySearchSchema = z.object({
  status: z
    .enum(['draft', 'pending', 'published', 'rejected', 'withdrawn'])
    .optional()
    .catch(undefined),
});
export const Route = createFileRoute(
  '/_authenticated/operations/opportunities',
)({
  validateSearch: (search: Record<string, unknown>) =>
    opportunitySearchSchema.parse(search),
  beforeLoad: ({ context, location }) => {
    if (context.session.session.activeOrganizationId !== defaultOrganizationId)
      return;
    return requirePermission(
      context.queryClient,
      location.href,
      'opportunities:read',
    );
  },
  component: OpportunitiesRoute,
});
function OpportunitiesRoute() {
  const { status } = Route.useSearch();
  const { session } = Route.useRouteContext();
  return (
    <PlatformWorkspace session={session}>
      <OpportunitiesPage key={status ?? 'all'} initialStatus={status} />
    </PlatformWorkspace>
  );
}
